
import { Input } from "element-ui"
import debounce from "lodash/debounce"
import { showGlobalMessage } from "@/utils/utils"

export default {
  name: "CmsInputNumber",
  components: {
    [Input.name]: Input
  },
  props: {
    value: {
      type: [Number, String],
      default: 1
    },
    sku: {
      type: [Number, String],
      default: ""
    },
    skuType: {
      type: [Number, String],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: 2
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99
    },
    styleConfig: {
      type: Object,
      default: () => {}
    },
    purchaseLimit: {
      type: Number,
      default: -1
    },
    remainingMaxCount: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      curValue: 1,
      focused: false,
      commonReqParams: {},
      oldValue: ""
    }
  },
  computed: {
    increaseDisabled() {
      return this.disabled || Number(this.curValue) >= this.max
    },
    reduceDisabled() {
      return this.disabled || Number(this.curValue) <= this.min
    },
    overPurchaseLimit() {
      if (this.purchaseLimit > 0) {
        const effectiveLimit = this.remainingMaxCount === -1 ? this.purchaseLimit : this.remainingMaxCount
        return Number(this.curValue) >= effectiveLimit
      }
      return false
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.curValue = newVal
        this.$emit("handleChange", this.curValue)
      }
    }
  },
  created() {
    if (!process.client) {
      return
    }
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams
    this.throttledLimitIncrease = debounce(() => {
      showGlobalMessage({
        message: this.$t("productDetails.limitPurchased", { purchaseLimit: this.purchaseLimit }),
        gap: 14,
        iconClass: "alert-info"
      })
    }, 500)
  },

  methods: {
    handleInput(value) {
      this.curValue = value.replace(/[^\d]/g, "")
      if (this.curValue == 0) {
        this.curValue = ""
      }

      if (this.purchaseLimit > 0) {
        const effectiveLimit = this.remainingMaxCount === -1 ? this.purchaseLimit : this.remainingMaxCount

        if (Number(this.curValue) >= effectiveLimit) {
          this.curValue = effectiveLimit || 1
          this.throttledLimitIncrease()
        }
      }
    },
    handleBlur() {
      this.focused = false
    },
    handleFocus() {
      this.focused = true
    },
    reduce() {
      this.handleChange("reduce", this.curValue)
    },
    increase() {
      if (this.overPurchaseLimit) {
        this.throttledLimitIncrease()
        return
      }
      if (this.increaseDisabled) return
      this.handleChange("increase", this.curValue)
    },
    handleChange(type = "change", value) {
      if (value === "") {
        this.curValue = value = this.min
      }
      // if (value > this.max) {
      //   this.curValue = value = this.max
      //   const headerEl = document.getElementById("top-box")
      //   const headerHeight = (headerEl && headerEl.clientHeight) || 0
      //   const gap = 16
      //   showGlobalMessage({
      //     message: this.$t("cart.maximumStockTips"),
      //     gap: headerHeight + gap,
      //     iconClass: "messageWarning"
      //   })
      // }
      if (this.focused) {
        this.$refs.input && this.$refs.input.blur()
      }
      let count = null
      if (type == "reduce") {
        count = Number(this.curValue) - 1
      } else if (type == "increase") {
        count = Number(this.curValue) + 1
      } else {
        count = Number(this.curValue)
      }
      if (count >= 1) {
        this.curValue = count
        // if (count >= this.max) {
        //   this.curValue = this.max
        // } else {
        //   this.curValue = count
        // }
      }
      this.$emit("handleChange", this.curValue)
    }
  }
}
